<template>
    <div v-if="canTrackManually">
        <i
            @click="$emit('edit-target', target)"
            class="fa fa-edit cursor-pointer mx-1 text-primary"
        ></i>
        <i
            @click="confirmDelete()"
            class="fa fa-times-circle-o cursor-pointer mx-1 text-primary"
        ></i>

        <delete-confirmation
            :id="`delete-data-${target.id}`"
            :visible="deleteConfirmation"
            :disabled="!userCanDeleteTracker"
            :button-text="'Yes, delete data'"
            @confirm="removeTracker()"
            @close="closeConfirmDelete()"
        >
            <template slot="title">
                Delete this data point?
            </template>
            <template slot="description">
                <p v-if="userCanDeleteTracker">
                    This action can not be undone.
                </p>
                <div v-else="" class="alert alert-warning">
                    <span
                        v-if="
                            helpers._get($root, 'organization.type', null) === 'professional_silver'
                        "
                    >
                        Only the goal or data creator can delete this entry.
                    </span>
                    <span v-else="">You are not authorized to perform this action.</span>
                </div>
            </template>
        </delete-confirmation>
    </div>
</template>

<script>
import { permissions } from "../../../plugins/permissions";
import DeleteConfirmation from "../../ui/DeleteConfirmation";

export default {
    name: "DataActions",
    inject: ["goal", "target"],
    mixins: [permissions],
    components: {
        DeleteConfirmation,
    },
    data() {
        return { deleteConfirmation: false };
    },
    computed: {
        userCanDeleteTracker() {
            switch (_.get(this.$root, "organization.type", null)) {
                case "professional_silver":
                    return (
                        this.goal.created_by_user.id === this.$root.user.id ||
                        this.target.created_by_user.id === this.$root.user.id
                    );
                case "professional_gold":
                case "professional_platinum":
                    return this.canTrackManually;
            }
        },
    },
    methods: {
        removeTracker() {
            this.closeConfirmDelete();
            this.$emit("delete-tracker");
        },
        confirmDelete() {
            this.deleteConfirmation = true;
        },
        closeConfirmDelete() {
            this.$set(this, "deleteConfirmation", false);
        },
        closeDetailsEdit() {
            this.$emit("close-details");
        },
    },
};
</script>

<style scoped></style>
